import type { PaginatedResponse } from '@/types/api';
import type { CompetencyGroup } from '@/types/competencies/CompetencyGroup';

import { api } from '@/api/api';

export default {
    async getCompetencyGroups(
        page = 1,
        pageSize = 50,
    ): Promise<PaginatedResponse<CompetencyGroup>> {
        const response = await api.get('/competencygroup', {
            params: { page, pageSize },
        });
        return response.data;
    },

    async getCompetencyGroupById(id: string): Promise<CompetencyGroup> {
        const response = await api.get(`/competencygroup/${id}`);
        return response.data;
    },

    async updateCompetencyGroup(competencyGroup: CompetencyGroup): Promise<CompetencyGroup> {
        const response = await api.put(`/competencygroup/${competencyGroup.id}`, competencyGroup);
        return response.data;
    },

    async createCompetencyGroup(
        competencyGroup: Omit<CompetencyGroup, 'id' | 'competencies'>,
    ): Promise<CompetencyGroup> {
        const response = await api.post('/competencygroup', competencyGroup);
        return response.data;
    },

    async deleteCompetencyGroup(id: string): Promise<void> {
        await api.delete(`/competencygroup/${id}`);
    },
};
